export enum PlanSmokerRateOverrideRuleStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export const PLAN_SMOKER_RATE_OVERRIDE_TEMPLATE = 'UPSERT_RULE' as const
export type PlanSmokerRateOverrideRuleTemplateKey =
  typeof PLAN_SMOKER_RATE_OVERRIDE_TEMPLATE
